module.exports = __webpack_public_path__ + "components/country-flag/static/ph-e215bab6b405d1afeff4e809f488ec41.svg";